import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields';
import enums from '../../../../constants/enums';

class ListingsFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
    } = this.props;

    return (
      <div className="filters-container admin-listings-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Is Addon:</label>
            <Select name="type" options={['yes', 'no']} selectLabel="-" emptyOption/>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default ListingsFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Listings/ListingFilters/ListingFilters.view.js